import React from 'react';

export const GameCardSkeleton = () => (
  <div className="relative min-h-[174px] sm:min-h-[194px] rounded-[24px] border border-white/[0.08] overflow-hidden flex" aria-hidden="true">
    <div className="skeleton w-[38%] sm:w-[35%]" />
    <div className="flex-1 p-4 sm:p-5 space-y-3">
      <div className="skeleton h-2.5 w-1/2 rounded" />
      <div className="skeleton h-4 w-3/4 rounded" />
      <div className="skeleton h-3 w-1/3 rounded mt-auto" />
    </div>
  </div>
);

export const GameGridSkeleton = ({ count = 6 }) => (
  <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5" role="status" aria-label="Carregando jogos">
    {Array.from({ length: count }).map((_, index) => <GameCardSkeleton key={index} />)}
  </div>
);

export const StatCardsSkeleton = () => (
  <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-3" role="status" aria-label="Carregando estatísticas" aria-hidden="true">
    {Array.from({ length: 6 }).map((_, index) => (
      <div key={index} className="surface p-4 sm:p-5">
        <div className="skeleton w-9 h-9 rounded-xl mb-4" />
        <div className="skeleton h-5 w-10 rounded mb-3" />
        <div className="skeleton h-3 w-16 rounded" />
      </div>
    ))}
  </div>
);
